import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { NgBsToastService } from 'ng-bs-toast-service';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-login',
    standalone: false,
    templateUrl: './login.component.html'
})
export class LoginComponent {

    constructor(
        private authService: AuthService,
        private router: Router,
        private toastService: NgBsToastService,
    ) {}

    readonly version = '1.3.1';
    readonly emailPattern = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

    username = '';
    password = '';
    loading = false;

    isEmailStructurallyValid(value: string): boolean {
        return this.emailPattern.test(value.trim());
    }

    isPasswordFilled(value: string): boolean {
        return value.trim().length > 0;
    }

    onSubmit(form: NgForm): void {
        if (!this.isEmailStructurallyValid(this.username) || !this.isPasswordFilled(this.password) || this.loading) {
            form.control.markAllAsTouched();
            return;
        }

        this.loading = true;

        this.authService
            .login({
                username: this.username.trim(),
                password: this.password,
            })
            .pipe(finalize(() => (this.loading = false)))
            .subscribe({
                next: () => {
                    void this.router.navigate(['/home-screen']);
                },
                error: (error: unknown) => {
                    if (error instanceof HttpErrorResponse && error.status === 401) {
                        this.toastService.send('Falha no login', 'Credenciais inválidas.', 'danger');
                        return;
                    }

                    this.toastService.send(
                        'Falha no login',
                        'Não foi possível autenticar.',
                        'danger',
                    );
                },
            });
    }
}
